import React, { Fragment } from 'react'

export default () => {
    return (
        <Fragment>
            <h1>Thank you for signing up!</h1>
            <div>You’ve been added to our mailing list.</div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/subscribe/success-subscribe.js